/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LicensingInfo } from './LicensingInfo';
import {
    LicensingInfoFromJSON,
    LicensingInfoFromJSONTyped,
    LicensingInfoToJSON,
    LicensingInfoToJSONTyped,
} from './LicensingInfo';

/**
 * 
 * @export
 * @interface Business1
 */
export interface Business1 {
    /**
     * 
     * @type {string}
     * @memberof Business1
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Business1
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Business1
     */
    display_name: string;
    /**
     * 
     * @type {number}
     * @memberof Business1
     */
    ref: number;
    /**
     * 
     * @type {number}
     * @memberof Business1
     */
    venues_count: number;
    /**
     * 
     * @type {number}
     * @memberof Business1
     */
    users_count: number;
    /**
     * 
     * @type {LicensingInfo}
     * @memberof Business1
     */
    licensing: LicensingInfo;
}

/**
 * Check if a given object implements the Business1 interface.
 */
export function instanceOfBusiness1(value: object): value is Business1 {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('display_name' in value) || value['display_name'] === undefined) return false;
    if (!('ref' in value) || value['ref'] === undefined) return false;
    if (!('venues_count' in value) || value['venues_count'] === undefined) return false;
    if (!('users_count' in value) || value['users_count'] === undefined) return false;
    if (!('licensing' in value) || value['licensing'] === undefined) return false;
    return true;
}

export function Business1FromJSON(json: any): Business1 {
    return Business1FromJSONTyped(json, false);
}

export function Business1FromJSONTyped(json: any, ignoreDiscriminator: boolean): Business1 {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'display_name': json['display_name'],
        'ref': json['ref'],
        'venues_count': json['venues_count'],
        'users_count': json['users_count'],
        'licensing': LicensingInfoFromJSON(json['licensing']),
    };
}

export function Business1ToJSON(json: any): Business1 {
    return Business1ToJSONTyped(json, false);
}

export function Business1ToJSONTyped(value?: Business1 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'display_name': value['display_name'],
        'ref': value['ref'],
        'venues_count': value['venues_count'],
        'users_count': value['users_count'],
        'licensing': LicensingInfoToJSON(value['licensing']),
    };
}

